import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, groupBy, flatten } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FilaSaldoCaja, GetFilasSaldoCajas, ObtenerSaldoCaja } from "./model";

//export type Entity = models.Movimientos;
export type Entity = FilaSaldoCaja;
type Column = kea.Grid2Column<Entity>;

const columnasFijas: kea.Grid2Column<Entity>[] = [
    { title: "Fecha", cell: x => ({ data: kea.toDate(x.Fecha) }) },
    { title: "Tipo mov", cell: x => ({ data: models.TipoMovimientoCajaView[x.TipoMovimiento] }) },
    { title: "Forma pago", cell: x => ({ data: models.FormaPagoMovimientoCaja[x.FormaPago] }) },
    { title: "Caja", cell: x => ({ data: x.NombreCaja }) },
    { title: "Importe", cell: x => ({ data: kea.formatCurrency(x.Importe) }) },
    { title: "Origen", cell: x => ({ data: models.OrigenMovimientoCaja[x.TipoOrigen] }) },
];

function columnasDinamicas(cajas: models.ImporteCaja[]): kea.Grid2Column<Entity>[] {

    var arreglo = cajas.map<kea.Grid2Column<Entity>>(x => ({
        title: x.Nombre,
        cell: c => ({ data: kea.formatCurrency(ObtenerSaldoCaja(c.Cajas, x.IdRegistro)) })
    }));

    return arreglo;
}

function botones(): kea.Grid2Column<Entity, undefined> {
    return kea.columnaBotones<Entity>([
    ]);
}

/**Obtiene las columnas del grid */
export function columnas(cajas: models.ImporteCaja[]): Column[] {
    return [botones(), ...columnasFijas, ...columnasDinamicas(cajas)];
}

const resource = resources.Turno;

export interface Props extends kea.ModalProps<number, boolean, FilaSaldoCaja[]> {
}

export class ConsultaCorteModalList extends React.PureComponent<Props> {
    idTurno = (props: Props) => props.value;

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    onDescargarReporte = async () => {
        const idTurno = this.idTurno(this.props);
        const reporte = await resource.GenerarReporteCorte(idTurno);
        kea.download(kea.base64ToBlob(reporte, 'application/vnd.ms-excel'), "Reporte corte.xls");
    };

    onReporteResumen = async () => {
        const idTurno = this.idTurno(this.props);
        const reporte = await resource.ReporteResumenTurno(idTurno);
        kea.openPdf(reporte, "Resumen de turno");
    }

    render() {
        const rows = this.props.params;
        const cajas = rows.map(x => x.Cajas);
        const value = this.props.value;
        const cols = columnas(cajas[0] || []);

        return (
            <kea.Modal
                buttons={[
                    <kea.Button children="Resumen de turno" onClick={this.onReporteResumen} />,
                    <kea.Button children="Generar Excel" style="success" onClick={this.onDescargarReporte} />,
                ]}
                onClose={this.onCerrar}
                title="Consulta de corte"
                fullScreen
            >
                <kea.Grid2 items={rows} columnas={cols} hideBusqueda />

            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/turnos/list/modales/modalconsultacorte.tsx